/* Limite de unidades por pedido — trava do lado da loja.

   Lê window.LofRewards.limite (cart-rewards-core.js) e age em três frentes:
   o seletor da página de produto, o botão "+" do carrinho e, como rede, um
   corte da quantidade que passou do limite.

   ATENÇÃO: isto evita que o cliente erre, não é garantia. A chamada
   /cart/add.js pode ser feita à mão por quem sabe mexer em requisição. Só uma
   função de validação no checkout bloqueia de verdade. */
(function () {
  'use strict';

  var R = window.LofRewards;
  if (!R || !R.limite) return;

  /* Mapa variante -> produto. Guardamos por variante para reconhecer a PDP pelo
     input escondido do formulário, e agrupamos por produto para que um produto
     de várias variantes não vire "uma unidade de cada". */
  var MAPA = R.limite.variantes;
  var MAX = R.limite.qtd;
  var NOTA = (R.limite.nota || 'Limite de {qtd} por pedido.').replace(/\{qtd\}/g, MAX);

  /* Estilo inline porque o theme.css é compilado com Tailwind e descarta classe
     que não aparece nos arquivos do tema — uma classe criada aqui não teria CSS. */
  var ESTILO = 'margin-top:.5rem;font-size:.75rem;line-height:1.3;color:hsl(var(--muted-foreground))';

  function produtoDe(varianteId) { return MAPA[String(varianteId)]; }

  function avisar(destino) {
    if (!destino || destino.querySelector('[data-limite-nota]')) return;
    var p = document.createElement('p');
    p.setAttribute('data-limite-nota', '');
    p.style.cssText = ESTILO;
    p.textContent = NOTA;
    destino.appendChild(p);
  }

  /* ───────── Página de produto ───────── */
  function travarProduto() {
    var sec = document.querySelector('[data-product-section]');
    if (!sec) return;
    var variante = sec.querySelector('[data-variant-id]');
    if (!variante || !produtoDe(variante.value)) return;

    var form = sec.querySelector('[data-product-form]');
    var input = sec.querySelector('[data-qty-input]');
    if (!input || !form) return;

    input.max = MAX;
    if ((parseInt(input.value, 10) || 1) > MAX) input.value = MAX;

    /* Com uma unidade só, o seletor é ruído: some, e o botão de adicionar fica
       com a linha inteira. */
    if (MAX === 1 && input.parentElement) input.parentElement.style.display = 'none';

    avisar(form);
  }

  /* ───────── Carrinho: drawer e página ───────── */
  var linhas = {};

  function pintarCarrinho(c) {
    linhas = {};
    c.items.forEach(function (i) { linhas[i.key] = i; });

    c.items.forEach(function (i) {
      if (R.ehBrinde(i) || !produtoDe(i.variant_id)) return;

      /* Na página /cart a mesma linha existe duas vezes no documento: o HTML
         vindo do servidor e o drawer. As duas precisam da trava. */
      document.querySelectorAll('[data-line-key="' + i.key + '"]').forEach(function (el) {
        var mais = el.querySelector('[data-line-inc]');
        if (mais) {
          mais.disabled = true;
          mais.style.opacity = '.35';
          mais.style.cursor = 'not-allowed';
        }

        /* Página /cart: o campo de quantidade é enviado no formulário. */
        var campo = el.querySelector('input[name="updates[]"]');
        if (campo) campo.max = MAX;

        avisar(el.querySelector('.flex-1') || el);
      });
    });
  }

  /* Corta o excedente, somando as linhas do mesmo produto. Linha de brinde não
     entra na conta nem é mexida: o brinde é decisão da loja, não do cliente, e
     quem cuida dela é o cart-gift.js. */
  function excedentes(c) {
    var restante = {};
    var acoes = [];

    c.items.forEach(function (i) {
      if (R.ehBrinde(i)) return;
      var produto = produtoDe(i.variant_id);
      if (!produto) return;

      if (restante[produto] === undefined) restante[produto] = MAX;
      var permitido = Math.min(i.quantity, restante[produto]);
      restante[produto] -= permitido;
      if (permitido !== i.quantity) acoes.push({ chave: i.key, qtd: permitido });
    });

    return acoes;
  }

  function mudar(chave, qtd) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: chave, quantity: qtd })
    }).then(function (r) {
      if (!r.ok) throw new Error('change ' + r.status);
      return r.json();
    });
  }

  var ocupado = false;

  function sincronizar() {
    if (ocupado) return;
    ocupado = true;

    R.carrinho()
      .then(function (c) {
        var acoes = excedentes(c);
        if (!acoes.length) { pintarCarrinho(c); return null; }
        return acoes.reduce(function (fila, a) {
          return fila.then(function () { return mudar(a.chave, a.qtd); });
        }, Promise.resolve()).then(R.rerenderizar);
      })
      .catch(function () {})
      .finally(function () { ocupado = false; });
  }

  /* Cancela o clique no "+" antes de o theme.js vê-lo. O ouvinte dele está no
     próprio botão (PDP) e no drawer (delegado); em captura, chegamos primeiro. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var mais = e.target.closest('[data-qty-plus]');
    if (mais) {
      var sec = mais.closest('[data-product-section]');
      var variante = sec && sec.querySelector('[data-variant-id]');
      var input = sec && sec.querySelector('[data-qty-input]');
      if (variante && input && produtoDe(variante.value) &&
          (parseInt(input.value, 10) || 1) >= MAX) {
        e.preventDefault();
        e.stopPropagation();
      }
      return;
    }

    var inc = e.target.closest('[data-line-inc]');
    if (inc) {
      var linha = inc.closest('[data-line-key]');
      var item = linha && linhas[linha.getAttribute('data-line-key')];
      if (item && !R.ehBrinde(item) && produtoDe(item.variant_id)) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }, true);

  travarProduto();

  var drawer = document.querySelector('[data-cart-drawer]');
  var subtotal = drawer && drawer.querySelector('[data-cart-subtotal]');
  var itens = drawer && drawer.querySelector('[data-cart-items]');
  if (window.MutationObserver) {
    if (subtotal) new MutationObserver(sincronizar).observe(subtotal, { childList: true, characterData: true, subtree: true });
    if (itens) new MutationObserver(sincronizar).observe(itens, { childList: true });
  }
  sincronizar();
})();
